module.exports = __webpack_public_path__ + "img/automation.19c4d27a.png";